import React, {
  Children,
  OptionHTMLAttributes,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from 'react'
import stringReplaceJsx from 'string-replace-jsx'
import { IconCheck } from '../../../icons/IconCheck'

export interface IResultItemProps extends OptionHTMLAttributes<HTMLOptionElement> {
  children?: string | string[]
  /** Оборачивает готовую подпись опции — например, чтобы поставить флаг слева */
  render?: (label: ReactNode) => ReactNode
  found?: string
  multiple?: boolean
  required?: boolean
}

export const ResultItem = (props: IResultItemProps) => {
  const {
    children,
    render,
    selected = false,
    found = '',
    className,
    multiple,
    required,
    ...optionProps
  } = props
  const [foundText, setFoundText] = useState<JSX.Element>()
  const ref = useRef<HTMLOptionElement>(null)

  useEffect(() => {
    if (!found) {
      setFoundText(undefined)
    } else if (children) {
      const regexFound = found
        .split('')
        .map((letter) => (letter.match(/[\w\s]/) ? letter : `\\${letter}`))
        .join('')
      Children.map(children, (child: string, index) => {
        const result = stringReplaceJsx(child, new RegExp(regexFound, 'gmi'), (match) => (
          <span key={index} className='text-default'>
            {match}
          </span>
        ))
        setFoundText(<>{result}</>)
      })
    }
  }, [found, children])

  return (
    <>
      <button
        className={`group flex w-full cursor-pointer items-center rounded-[8px] p-[8px] text-[15px] leading-[24px] hover:bg-default-200 ${selected ? 'text-aqua-300' : `text-focus-500 ${!found && 'hover:text-default'}`} ${!multiple && required && selected && 'pointer-events-none'} ${className} `}
        type='button'
        onClick={() => {
          if (ref?.current) ref.current.click()
        }}
      >
        <div className={'truncate text-start'}>
          {render ? render(foundText ? foundText : children) : foundText ? foundText : children}
        </div>
        {selected && (
          <div className='ml-auto flex w-[20px] shrink-0 items-center pl-[5px] text-default'>
            <IconCheck color='#00326D' />
          </div>
        )}
      </button>
      <option ref={ref} {...optionProps} hidden></option>
    </>
  )
}
